<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <span class="title">
                        <b>Novo Administrador</b>

                        <i class="fa fa-user-circle" style="float:right;margin-top:6px;font-size:21px;"></i>
                    </span>

                    <hr class="m-t-md">
                </div>
            </div>

            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-4">
                            <label for="name">Nome</label>
                            <input type="text" class="form-control" name="name" v-model="user.name">
                            <small></small>
                        </div>

                        <div class="col-md-4">
                            <label for="email">E-mail</label>
                            <input type="text" class="form-control" name="email" v-model="user.email">
                        </div>

                        <div class="col-md-4">
                            <label for="role">Papel</label>
                            <select name="role" class="form-control" id="role" v-model="user.role">
                                <option value="" disabled>Selecione uma opção</option>
                                <option value="2">Administrador</option>
                                <option value="3">Operador</option>
                                <option value="5">Notificador</option>
                            </select>
                        </div>

                        <div class="col-md-4 m-t-sm">
                            <label for="name">Senha</label>
                            <input type="password" class="form-control" name="password" v-model="user.password">
                        </div>

                        <div class="col-md-4 m-t-sm">
                            <label for="password_confirmation">Confirmação de Senha</label>
                            <input type="password" class="form-control" name="password_confirmation"
                                   v-model="user.password_confirmation">
                        </div>
                    </div>

                    <hr class="m-t-lg">

                    <div class="block text-right">
                        <router-link to="/admin" class="btn btn-info m-r-sm">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                        <a class="btn btn-success" @click="save">
                            Salvar <i class="fa fa-save"></i>
                        </a>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
    // import axios from 'axios'
    export default {
        data() {
            return {
                user: {
                    name: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    role: ''
                },
                errors: undefined
            }
        },
        methods: {
            save: function () {
                const api = this.$store.state.api + 'user';
                const self = this;

                self.$http.post(api, this.user)
                    .then((response) => {
                        self.users = response.data.data;
                        self.tableData = self.users;

                        self.$message('Sucesso', `Usuário ${self.user.name} cadastrado com sucesso`, 'success');

                        self.user = {
                            name: '',
                            email: '',
                            password: '',
                            password_confirmation: '',
                            role: ''
                        };
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Admin/Add.vue